const DEFAULT_PORT = Number.parseInt(process.env.REACT_APP_API_PORT || '3001', 10);

const isBrowser = typeof window !== 'undefined';

const isLocalNetworkHost = (hostname) => {
  const patterns = [
    /^192\.168\./,
    /^10\./,
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./,
    /^169\.254\./,
  ];

  return patterns.some((pattern) => pattern.test(hostname));
};

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }

  if (!isBrowser) {
    return `http://localhost:${DEFAULT_PORT}`;
  }

  const { location } = window;
  const hostname = location.hostname || 'localhost';
  const protocol = location.protocol || 'http:';

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//localhost:${DEFAULT_PORT}`;
  }

  if (isLocalNetworkHost(hostname)) {
    return `${protocol}//${hostname}:${DEFAULT_PORT}`;
  }

  return `${protocol}//${hostname}:${DEFAULT_PORT}`;
};

export const buildApiUrl = (endpoint = '/') => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${getApiBaseUrl()}${cleanEndpoint}`;
};

export const buildAssetUrl = (resourcePath = '') => {
  if (!resourcePath) return '';
  if (/^https?:\/\//i.test(resourcePath)) {
    return resourcePath;
  }

  if (resourcePath.startsWith('/')) {
    return `${getApiBaseUrl()}${resourcePath}`;
  }

  return `${getApiBaseUrl()}/${resourcePath}`;
};


